import { Skeleton, SkeletonTableRow, SkeletonMobileCard } from '../UI/Skeleton';

/**
 * ExpensesSkeleton - Loading skeleton for the expenses list view
 */
export default function ExpensesSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <div>
          <Skeleton width="120px" height="1.75rem" className="mb-2" />
          <Skeleton width="220px" height="1rem" />
        </div>
      </div>

      {/* Filters skeleton */}
      <div className="flex flex-wrap gap-3">
        <Skeleton width="150px" height="2.5rem" rounded="md" />
        <Skeleton width="130px" height="2.5rem" rounded="md" />
      </div>

      {/* Summary cards skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <div 
            key={i}
            className="p-4 rounded-lg"
            style={{ 
              backgroundColor: 'var(--color-bg-canvas)',
              border: '1px solid var(--color-border-subtle)',
            }}
          >
            <Skeleton width="80px" height="0.75rem" className="mb-2" />
            <Skeleton width="100px" height="1.5rem" />
          </div>
        ))}
      </div>

      {/* Desktop table skeleton */}
      <div 
        className="hidden md:block rounded-lg overflow-hidden"
        style={{ 
          backgroundColor: 'var(--color-bg-canvas)',
          border: '1px solid var(--color-border-subtle)',
        }}
      >
        <table className="w-full">
          <thead>
            <tr style={{ backgroundColor: 'var(--color-bg-surface)' }}>
              {['Description', 'Category', 'Date', 'Amount', 'Status', 'Actions'].map((col) => (
                <th key={col} className="px-4 py-3 text-left">
                  <Skeleton width={col === 'Actions' ? '60px' : '70%'} height="0.875rem" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 }).map((_, i) => (
              <SkeletonTableRow key={i} columns={6} />
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards skeleton */}
      <div className="md:hidden space-y-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <SkeletonMobileCard key={i} />
        ))}
      </div>
    </div>
  );
}
